import React from 'react'

import PartnerList from '../PartnerList'

const SortableComponentElements = ({
  sortableComponentNoResultsText,
  sortableComponentSortableFields,
  sortableComponentType,
  sortableData,
  sortableFieldItems,
  nodeLocale,
}) => {
  const filteredData = sortableData.filter(({ node }) =>
    node.type.includes(sortableComponentType)
  )

  const filteredFieldItems = sortableFieldItems.filter(({ node }) =>
    sortableComponentSortableFields.includes(node.id)
  )

  return (
    <PartnerList
      sortableComponentNoResultsText={sortableComponentNoResultsText}
      sortableComponentSortableFields={sortableComponentSortableFields}
      sortableData={filteredData}
      sortableFieldItems={filteredFieldItems}
      nodeLocale={nodeLocale}
    />
  )
}

export default SortableComponentElements
